// Game mode shape shared by every game so far. New per-game modes would add a
// new union member here and a corresponding entry in ModeOpponentStrings.
export type SessionMode = "ai" | "local" | "online";

// Caller projects the bits we need out of their per-game ActiveSession.seed.
// Decouples the helper from per-app session shapes / i18n.
export interface ModeOpponentInput {
  readonly mode: SessionMode;
  // For "ai" mode: pre-translated difficulty label (e.g. "Normal").
  readonly difficultyLabel?: string | null;
  // For "online" mode: opponent display name. Empty/null falls back to
  // `strings.opponent`.
  readonly opponentName?: string | null;
}

export interface ModeOpponentStrings {
  readonly vsAi: (difficultyLabel: string) => string;
  readonly local: string;
  readonly online: (opponentName: string) => string;
  // Fallback name when the online opponent is anonymous.
  readonly opponent: string;
}

export function modeOpponentLabel(
  input: ModeOpponentInput,
  strings: ModeOpponentStrings,
): string {
  switch (input.mode) {
    case "ai":
      return strings.vsAi(input.difficultyLabel ?? "");
    case "local":
      return strings.local;
    case "online":
      return strings.online(input.opponentName || strings.opponent);
  }
}
